const GLOBAL_PATH = (option = {})=>{
	const _type = option.type;
	const _service = option.service;
	const _menu = option.menu;
	const _locale = option.locale ? option.locale : 'ko-KR';
	const _country = option.country ? option.country.toLowerCase() : 'kr';
	const _path = window._rootPath || window._path;
	let _globalPath = {
		api: { // API
			tricksterm : {
				// cmazit: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				// cmbest: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path +'conti/getContent?service='+ _service +'&alias=gb-pop&lang=' + _locale,
				nctv: '/v1/videos/official?game='+ _service +'&page=1&pageSize=20',
				movie: '/'+ _service +'/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/'+ _service +'/myfeed/articles', // community-api
				news: _path +'conti/getContent?service='+ _service +'&alias=nchome-news&lang=' + _locale, // conti
				// shortcut: _path +'conti/getContent?service='+ _service +'&alias=nchome-shortcut&lang=' + _locale, // conti
				// appdown: _path +'conti/getContent?service='+ _service +'&alias=nchome-appdown&lang=' + _locale, // conti
				promotion: _path +'conti/getContent?service='+ _service +'&alias=nchome-promotion&lang=' + _locale, // conti,
				group: _path +'conti/getContentGroup?service='+ _service +'&groupAlias=nchome'+ _service +'&subAlias=' + _locale
			},
			h3 : {
				cmazit: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				cmbest: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path +'conti/getContent?service='+ _service +'&alias=gb-pop&lang=' + _locale,
				nctv: '/v1/videos/official?game='+ _service +'&page=1&pageSize=20',
				movie: '/'+ _service +'/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/'+ _service +'/myfeed/articles', // community-api
				news: _path +'conti/getContent?service='+ _service +'&alias=nchome-news&lang=' + _locale, // conti
				shortcut: _path +'conti/getContent?service='+ _service +'&alias=nchome-shortcut&lang=' + _locale, // conti
				appdown: _path +'conti/getContent?service='+ _service +'&alias=nchome-appdown&lang=' + _locale, // conti
				promotion: _path +'conti/getContent?service='+ _service +'&alias=nchome-promotion&lang=' + _locale, // conti,
				group: _path +'conti/getContentGroup?service='+ _service +'&groupAlias=nchome'+ _service +'&subAlias=' + _locale
			},
			bns2 : {
				cmazit: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				cmbest: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path +'conti/getContent?service='+ _service +'&alias=gb-pop&lang=' + _locale,
				nctv: '/v1/videos/official?game='+ _service +'&page=1&pageSize=20',
				movie: '/'+ _service +'/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/'+ _service +'/myfeed/articles', // community-api
				news: _path +'conti/getContent?service='+ _service +'&alias=nchome-news&lang=' + _locale, // conti
				shortcut: _path +'conti/getContent?service='+ _service +'&alias=nchome-shortcut&lang=' + _locale, // conti
				appdown: _path +'conti/getContent?service='+ _service +'&alias=nchome-appdown&lang=' + _locale, // conti
				promotion: _path +'conti/getContent?service='+ _service +'&alias=nchome-promotion&lang=' + _locale, // conti,
				group: _path +'conti/getContentGroup?service='+ _service +'&groupAlias=nchome'+ _service +'&subAlias=' + _locale
			},
			lineagew: {
				cmazit: '/'+ _country +'/maincontents/data?contentAlias=nchome-cmpick-azit',
				guidebook: '/'+ _country +'/conti/getContent?service=lineagew&alias=lineagew-'+ _country +'-gb-pop&lang=' + _locale,
				cmbest: '/'+ _country +'/maincontents/data?contentAlias=nchome-cmpick-best',
				nctv: '/v1/videos/official?game=linw&page=1&pageSize=20',
				movie: '/linw/board/movie_clip_'+ _country +'/article/search/moreArticle',
				myfeed: '/linw/myfeed/articles'
			},
			lineage2mru: {
				cmazit: _path +'conti/getContent?service=l2mru&alias=nchome-cmpick-azit&lang='+ _locale, // conti
				cmbest: _path +'conti/getContent?service=l2mru&alias=nchome-cmpick-best&lang='+ _locale, // conti
				guidebook: _path +'conti/getContent?service=l2mru&alias=l2mru-'+ _country +'-gb-pop&lang='+ _locale,
				nctv: '/v1/videos/official?game=l2mru&page=1&pageSize=20',
				movie: '/l2mru/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/l2mru/myfeed/articles', // community-api
				news: _path +'conti/getContent?service=l2mru&alias=nchome-news&lang='+ _locale, // conti
				shortcut: _path +'conti/getContent?service=l2mru&alias=nchome-shortcut&lang='+ _locale, // conti
				appdown: _path +'conti/getContent?service=l2mru&alias=nchome-appdown&lang='+ _locale, // conti
				promotion: _path +'conti/getContent?service=l2mru&alias=nchome-promotion&lang='+ _locale, // conti,
				group: _path +'conti/getContentGroup?service=l2mru&groupAlias=nchomel2mru&subAlias='+ _locale
			},
			lineage2mnaeu: {
				cmazit: _path + 'conti/getContent?service=l2mnu&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				cmbest: _path + 'conti/getContent?service=l2mnu&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path + 'conti/getContent?service=l2mnu&alias=l2mnu-'+ _country +'-gb-pop&lang='+ _locale,
				nctv: '/v1/videos/official?game=l2mnu&page=1&pageSize=20',
				movie: '/l2mnu/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/l2mnu/myfeed/articles', // community-api
				news: _path +'conti/getContent?service=l2mnu&alias=nchome-news&lang='+ _locale, // conti
				shortcut: _path +'conti/getContent?service=l2mnu&alias=nchome-shortcut&lang='+ _locale, // conti
				appdown: _path +'conti/getContent?service=l2mnu&alias=nchome-appdown&lang='+ _locale, // conti
				promotion: _path +'conti/getContent?service=l2mnu&alias=nchome-promotion&lang='+ _locale, // conti,
				group: _path +'conti/getContentGroup?service=l2mnu&groupAlias=nchomel2mnu&subAlias='+ _locale
			},
			lineagem : {
				cmazit: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				cmbest: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path +'conti/getContent?service='+ _service +'&alias=gb-pop&lang=' + _locale,
				nctv: '/v1/videos/official?game='+ _service +'&page=1&pageSize=20',
				movie: '/'+ _service +'/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/'+ _service +'/myfeed/articles', // community-api
				news: _path +'conti/getContent?service='+ _service +'&alias=nchome-news&lang=' + _locale, // conti
				shortcut: _path +'conti/getContent?service='+ _service +'&alias=nchome-shortcut&lang=' + _locale, // conti
				appdown: _path +'conti/getContent?service='+ _service +'&alias=nchome-appdown&lang=' + _locale, // conti
				promotion: _path +'conti/getContent?service='+ _service +'&alias=nchome-promotion&lang=' + _locale, // conti,
				group: _path +'conti/getContentGroup?service='+ _service +'&groupAlias=nchome'+ _service +'&subAlias=' + _locale
			},
			lineage2m : {
				cmazit: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-azit&lang=' + _locale, // conti
				cmbest: _path +'conti/getContent?service='+ _service +'&alias=nchome-cmpick-best&lang=' + _locale, // conti
				guidebook: _path +'conti/getContent?service='+ _service +'&alias=gb-pop&lang=' + _locale,
				nctv: '/v1/videos/official?game='+ _service +'&page=1&pageSize=20',
				movie: '/l2m/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/l2m/myfeed/articles', // community-api
				news: _path +'conti/getContent?service='+ _service +'&alias=nchome-news&lang=' + _locale, // conti
				shortcut: _path +'conti/getContent?service='+ _service +'&alias=nchome-shortcut&lang=' + _locale, // conti
				appdown: _path +'conti/getContent?service='+ _service +'&alias=nchome-appdown&lang=' + _locale, // conti
				promotion: _path +'conti/getContent?service='+ _service +'&alias=nchome-promotion&lang=' + _locale, // conti,
				group: _path +'conti/getContentGroup?service='+ _service +'&groupAlias=nchome'+ _service +'&subAlias=' + _locale
			},
			lineage2mnct: {
				cmazit: _path +'conti/getContent?service=l2mnct&alias=nchome-cmpick-azit&lang='+ _locale, // conti
				cmbest: _path +'conti/getContent?service=l2mnct&alias=nchome-cmpick-best&lang='+ _locale, // conti
				guidebook: _path +'conti/getContent?service=l2mnct&alias=gb-pop&lang='+ _locale,
				nctv: '/v1/videos/official?game=l2mnct&page=1&pageSize=20',
				movie: '/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/myfeed/articles', // community-api
				news: _path +'conti/getContent?service=l2mnct&alias=nchome-news&lang='+ _locale, // conti
				shortcut: _path +'conti/getContent?service=l2mnct&alias=nchome-shortcut&lang='+ _locale, // conti
				appdown: _path +'conti/getContent?service=l2mnct&alias=nchome-appdown&lang='+ _locale, // conti
				promotion: _path +'conti/getContent?service=l2mnct&alias=nchome-promotion&lang='+ _locale, // conti,
				group: _path +'conti/getContentGroup?service=l2mnct&groupAlias=nchomel2mnct&subAlias='+ _locale
			},
			lineage2mncj: {
				cmazit: _path +'conti/getContent?service=l2mncj&alias=nchome-cmpick-azit&lang='+ _locale, // conti
				cmbest: _path +'conti/getContent?service=l2mncj&alias=nchome-cmpick-best&lang='+ _locale, // conti
				guidebook: _path +'conti/getContent?service=l2mncj&alias=gb-pop&lang='+ _locale,
				nctv: '/v1/videos/official?game=l2mncj&page=1&pageSize=20',
				movie: '/board/movie_clip/article/search/moreArticle', // community-api
				myfeed: '/myfeed/articles', // community-api
				news: _path +'conti/getContent?service=l2mncj&alias=nchome-news&lang='+ _locale, // conti
				shortcut: _path +'conti/getContent?service=l2mncj&alias=nchome-shortcut&lang='+ _locale, // conti
				appdown: _path +'conti/getContent?service=l2mncj&alias=nchome-appdown&lang='+ _locale, // conti
				promotion: _path +'conti/getContent?service=l2mncj&alias=nchome-promotion&lang='+ _locale, // conti,
				group: _path +'conti/getContentGroup?service=l2mncj&groupAlias=nchomel2mncj&subAlias='+ _locale
			}
		},
		url : { // 더보기 URL, 운영툴 입력 안 될 경우 디폴트 값
			tricksterm : {
				cmazit: '/board/cm_story/list',
				guidebook: '/guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: '/board/movie_clip/'
			},
			h3 : {
				cmazit: '/board/cm_story/list',
				guidebook: '/guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: '/board/movie_clip/'
			},
			bns2 : {
				cmazit: '/board/cm_story/list',
				guidebook: '/guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: '/board/movie_clip/'
			},
			lineagew: {
				cmazit: '/' + _country + '/board/cm_story/list',
				guidebook: '/' + _country + '/guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: '/' + _country + '/board/movie_clip/'
			},
			lineage2mru: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			},
			lineage2mnaeu: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			},
			lineagem: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			},
			lineage2m: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			},
			lineage2mnct: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			},
			lineage2mncj: {
				cmazit: _path + 'board/cm_story/list',
				guidebook: _path + 'guidebook/',
				cmbest: '',
				nctv: 'https://www.youtube.com/user/plaync',
				movie: _path + 'board/movie_clip/'
			}
		}
	};
	return _globalPath[_type][_service][_menu];

} // GLOBAL_PATH

const API_DOMAIN  = {
	NCT_COMMUNITY : {
		OPDEV : 'https://opdev-api-tw-community.plaync.com',
		SB : 'https://sb-api-community.plaync.com/l2m_tw',
		RC : 'https://rc-api-tw-community.ncsoft.com/l2m',
		STAGE : 'https://api-tw-community.ncsoft.com/l2m',
		LIVE : 'https://api-tw-community.ncsoft.com/l2m'
	},
	NCJ_COMMUNITY : {
		OPDEV : 'https://opdev-api-jp-community.plaync.com',
		SB : ' https://sb-api-community.plaync.com/l2m_jp',
		RC : 'https://rc-api-jp-community.ncsoft.jp/l2m',
		STAGE : 'https://api-jp-community.ncsoft.jp/l2m',
		LIVE : 'https://api-jp-community.ncsoft.jp/l2m'
	},
	GLOBAL_COMMUNITY : {
		OPDEV : 'https://opdev-api-global-community.plaync.com',
		SB : 'https://sb-api-global-community.plaync.com',
		RC : 'https://rc-api-global-community.plaync.com',
		STAGE : 'https://api-global-community.plaync.com',
		LIVE : 'https://api-global-community.plaync.com'
	},
	COMMUNITY : {
		OPDEV : 'https://opdev-api-community.plaync.com',
		SB : 'https://sb-api-community.plaync.com',
		RC : 'https://rc-api-community.plaync.com',
		STAGE : 'https://api-community.plaync.com',
		LIVE : 'https://api-community.plaync.com'
	},
	NCTV : {
		OPDEV : 'https://opdev-api-nctv.plaync.com',
		SB : 'https://sb-api-nctv.plaync.com',
		RC : 'https://rc-api-nctv.plaync.com',
		STAGE : 'https://api-nctv.plaync.com',
		LIVE : 'https://api-nctv.plaync.com'
	}
};

const TAB = {
	CMPICK : 'cmpick',
	POPULARITY : 'popularity',
	MYFEED : 'myfeed',
	COOKIENAME : 'TricksterM_MyTab'
};

const MYFEED = {
	TAG : {
		TYPE : 'TAG',
		CATEGORY_NAME : {
			'tricksterm' : '#클래스',
			'h3' : '#클래스',
			'bns2' : '#무기',
			'lineagew' : '#',
			'lineagem': '#',
			'lineage2m': '#클래스',
			'lineage2mru': '#',
			'lineage2mnaeu': '#',
			'lineage2mncj': '#クラス',
			'lineage2mnct': '#職業'
		}
	},
	BOARD : {
		TYPE : 'BOARD',
		CATEGORY_NAME : ''
	},
	MESSAGE_NODATA : {
		'tricksterm' : 'MY 피드에서는 컴퍼니 아지트의 새 글을 모아 보여드립니다.',
		'h3' : 'MY 피드에서는 새 글을 모아 보여드립니다.',
		'bns2' : 'MY 피드에서는 문파 장원의 새 글,<br> 내 대표 캐릭터의 무기와 관련된 태그로 등록된 <br> 새 글을 모아 보여드립니다.',
		'lineage2m': 'MY 피드에서는 혈맹 아지트의 새글,<br> 내 대표 캐릭터 클래스와 관련된 태그로 등록된 <br> 새 글을 모아 보여드립니다.'
	}
};

const STORE = {
	SWIPER : {
		homeContentSwiper : {}
	},
	data : {
		promotion: {},
		cmazit : {},
		cmbest : {},
		guidebook : {},
		// channel : {},
		movie : {},
		topArticle : {},
		topQnanknowhow : {},
		qnanknowhow : {},
		topScrap : {},
		pwa: {},
		pwaBanner : {},
		news: {},
		appdown: {},
		shortcut: {},
		myfeed: {}
	},
	url : { // 운영툴에 값이 없을 경우에만
		cmazit : '/board/cm_story/list', //  cmazitCommunity에서만 지금은 모두 운영툴
		guide : '/guidebook/index',
		cmbest : '',
		// channel : 'https://www.youtube.com/user/plaync', // 채널 삭제
		movie : '/board/movie_clip/list'
	},
	title : { // 운영툴에 입력값이 없을 경우에
		cmazit : 'CM 아지트',
		guide : '가이드북',
		cmbest : '인챈트 도전기 베스트',
		// channel : 'CH : NPC', // 채널 삭제
		movie : '공식 동영상',
		topArticle :  null,
		topQnanknowhow :  null,
		qnanknowhow :  null,
		topScrap :  null,
	},
	pwa : null,
	pwaLayer : null
};

export {
	GLOBAL_PATH,
	API_DOMAIN,
	STORE,
	TAB,
	MYFEED
}